/**
 * Vidéos à la demande : les <video data-lazy-video> n'ont ni autoplay ni
 * préchargement. On lance la lecture quand elles approchent de l'écran et on
 * les met en pause quand elles en sortent (économie de données et de CPU,
 * surtout sur mobile).
 */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('video[data-lazy-video]').forEach(function (v) {
      v.preload = 'metadata';
      v.play().catch(function () {});
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          if (video.preload === 'none') video.preload = 'auto';
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  function observe(root) {
    (root || document).querySelectorAll('video[data-lazy-video]:not([data-lazy-bound])').forEach(function (v) {
      v.dataset.lazyBound = 'true';
      observer.observe(v);
    });
  }

  observe(document);

  /* Contenu injecté plus tard (recommandations, quick view, panier) */
  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) observe(added[j]);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
